import React from 'react'
import { Autocomplete, Chip, TextField } from '@mui/material'
import { useAudienceColor } from '../../shared/hooks/useAudienceColor'
import { useGetSettingsQuery } from '../../shared/queries/useGetSettingsQuery'

type StrategicImperativeAudiencesFieldProps = {
    value: string[]
    onChange: (audiences: string[]) => void
}

export const StrategicImperativeAudiencesField = ({ value, onChange }: StrategicImperativeAudiencesFieldProps) => {
    const { data, isLoading } = useGetSettingsQuery()
    const getAudienceColor = useAudienceColor()

    // Still offers an audience since removed from settings, or the picker rejects the one it holds.
    const options = Array.from(new Set([...(data?.vmAudiences ?? []), ...value]))

    return (
        <Autocomplete
            multiple
            disableCloseOnSelect
            options={options}
            value={value}
            loading={isLoading}
            onChange={(_event, audiences) => onChange(audiences)}
            renderTags={(audiences, getTagProps) =>
                audiences.map((audience, index) => (
                    <Chip
                        {...getTagProps({ index })}
                        key={audience}
                        size="small"
                        label={audience}
                        sx={{
                            bgcolor: getAudienceColor(audience),
                            color: 'figma.accentColors.white',
                            '& .MuiChip-deleteIcon': { color: 'inherit' },
                        }}
                    />
                ))
            }
            renderInput={(params) => <TextField {...params} variant="filled" placeholder="Select audiences" />}
        />
    )
}

export default StrategicImperativeAudiencesField
